<template lang="pug">
label.v-field-checkbox.field-checkbox(:class="{'field-checkbox--radio': radio, 'field-checkbox--disabled': disabled}")
	input.field-checkbox__input(
			:type="radio ? 'radio' : 'checkbox'"
			:value="trueValue"
			v-model="localValue"
			@change="handleInput"
			:disabled="disabled"
			:aria-labelledby="(labelId ? labelId + ' ' + uniqueId : null)"
			:id="uniqueId")
	img.field-checkbox__icon(v-if="icon" :src="icon" alt="")
	span.field-checkbox__visual
	template(v-if="note" )
		.field-checkbox__info
			.field-checkbox__text(v-html="computedText")
			.field-checkbox__note(v-html="note")
	template(v-else )
		span.field-checkbox__text(v-html="computedText")
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	props: {
		radio: {
			type: Boolean,
			default: false
		},

		icon: {
			type: [String, Object],
			default: null
		},

		note: {
			type: String,
			default: null
		},

		text: {
			type: [String, Number],
			default: null
		},

		number: {
			type: Number,
			default: null
		},

		modelValue: {
			type: [Object, String, Number, Boolean],
			default: null
		},

		trueValue: {
			type: [Object, String, Number, Boolean],
			default: null
		},

		disabled: {
			type: Boolean,
			default: false
		},

		labelId: {
			type: String,
			default: null
		},

		type: {
			type: String,
			default: null,
		},

		lang: {
			type: String,
			default: null,
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			open: false,
			uniqueId: uniqueId('field-')
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput() {
			if(this.type && this.type === 'translate') {
				this.$emit('update:model-value', {auto: this.localValue, lang: this.lang});
			} else {
				this.$emit('update:model-value', this.localValue);
			}
		}
	},

	computed: {
		computedText() {
			if(this.number || this.number === 0) {
				if(this.number === 0) {
					return `<span class="c-gray">${this.text}<span class="field-checkbox__number c-gray">${this.number}</span></span>`
				}
				return `${this.text}<span class="field-checkbox__number">${this.number}</span>`
			}
			return this.text
		}
	}
};
</script>
